export function getCheckSystemBetsPage(isMobile) {
	const defaultPage = '/checksystembets';
	if (isMobile) {
		return (window.appConfig && window.appConfig.ROUTES && window.appConfig.ROUTES.prematch && window.appConfig.ROUTES.prematch.checksystembets) || defaultPage;
	}else{
		return (window.appConfig && window.appConfig.ROUTES && window.appConfig.ROUTES.checksystembets && window.appConfig.ROUTES.checksystembets['checksystembets']) || defaultPage;
	}
}
